'use client';

import { TopRibbonLoader } from '@app/app/_components/TopRibbonLoader/TobRibbonLoader';
import { ClientSwitcherOption } from '@app/app/_widgets/ProfileMenu/components/ClientSwitcherOption';
import { Client } from '@app/domain/model/Client';
import { FormStatus } from '@app/lib/form/contracts/FormStatus';
import { selectClient } from '@app/service/auth/actions/selectClient';
import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useFormState } from 'react-dom';

interface Props {
    clients: Client[];
    selectedClientId?: string;
    onSuccess?: () => void;
}

export function ClientSwitcher({ clients, selectedClientId, onSuccess }: Props) {
    const router = useRouter();

    const pathname = usePathname();
    const formRef = useRef<HTMLFormElement>(null);

    const [formState, formAction] = useFormState(selectClient, { status: FormStatus.Pending });

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = useCallback(() => {
        setIsLoading(true);
        formRef.current?.requestSubmit();
    }, []);

    useEffect(() => {
        if (formState.status === FormStatus.Success) {
            if (pathname.includes('/self-service')) router.replace('/self-service');

            setIsLoading(false);

            onSuccess?.();
        }
        if (formState.status === FormStatus.Error) {
            setIsLoading(false);
        }
    }, [formState, onSuccess, pathname, router]);

    return (
        <>
            {isLoading && <TopRibbonLoader />}
            <form ref={formRef} action={formAction} className="flex max-h-[50%] flex-col gap-1 overflow-y-auto">
                {clients.map(client => (
                    <ClientSwitcherOption
                        key={client.id}
                        id={client.id}
                        checked={client.id === selectedClientId}
                        onChange={handleChange}>
                        {client.fullName}
                    </ClientSwitcherOption>
                ))}
            </form>
        </>
    );
}
